import React, { useState, useEffect, useMemo, useCallback,useRef } from "react";
import {
  Container,
  Select,
  MenuItem,
  Button,
  Grid,
  Box,
  Typography,
  Divider,
  FormControl,
  Stack,
  Avatar,
  Input,
  OutlinedInput,
  Chip,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  List,
  Skeleton,
} from "@mui/material";
import { InputAdornment } from "@mui/material";
import ind_number_plat from "../../assets/images/ind-number-plat.png";
import NumberPlateDialog from "../../components/commenMUI/dialogs/NumberPlateDialog";
import { addUserCar } from "../../services/user";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  getCarBrands,
  getCarCompatibilitys,
  getCarModels,
  getCarCompatibilitysVarient,
} from "../../services/home";
import { getNumberplate } from "../../services/sprint-verify";
import toast from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import { getPetrolPrice } from "../../services/sprint-verify";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer, } from 'react-toastify';
import { getcatelogcategory } from "./../../services/category";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useSelectedCar } from "../../utils/SelectedCar";


const LoadingMenuItem = () => (
  <MenuItem
    disabled
    MenuProps={{
      sx: { minHeight: "350px", maxHeight: "350px" },
    }}
    sx={{ display: 'flex', justifyContent: 'center', padding: '10px' }}
  >
    <CircularProgress size={20} sx={{ color: '#FF6633' }} />
  </MenuItem>
);

const SearchForm = ({
  isMobile,
  brandsList,
  yearsList,
  compatibilitysList,
  modelsList,
  handleSearchAndOpenDialog,
  handleSearch,
  handleAdd1,
  handleNumberPlateChange,
  handleKeyPress,
  dropdownEnabled,
  dropdownValues,
  numberPlateSearch,
  varientList,
  setDropdownValues,
  setDropdownEnabled,
  setLoading,
  loading,
}) => {

  const handleDropdownChange = useCallback(async (dropdownName, value) => {
    const dropdownNumber = parseInt(dropdownName.slice(-1));

    // Update the selected value
    setDropdownValues(prev => {
      const newValues = { ...prev, [dropdownName]: value };
      // Reset subsequent dropdowns
      for (let i = dropdownNumber + 1; i <= 4; i++) {
        newValues[`dropdown${i}`] = "0";
      }
      return newValues;
    });

    // Set loading state based on which dropdown changed
    if (dropdownName === 'dropdown1') {
      setLoading(prev => ({ ...prev, models: true }));
    } else if (dropdownName === 'dropdown2') {
      setLoading(prev => ({ ...prev, years: true }));
    } else if (dropdownName === 'dropdown3') {
      setLoading(prev => ({ ...prev, variants: true }));
    }

    setDropdownEnabled(prev => {
      const newEnabled = { ...prev };
      for (let i = dropdownNumber + 1; i <= 4; i++) {
        newEnabled[`dropdown${i}`] = false;
      }
      const nextDropdown = `dropdown${dropdownNumber + 1}`;
      if (nextDropdown in newEnabled) {
        newEnabled[nextDropdown] = true;
      }
      return newEnabled;
    });
  }, []);


  const commonSelectStyles = {
    height: isMobile ? "45px" : "45px",
    borderRadius: isMobile ? "7px" : "10px",
    backgroundColor: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "'Barlow', sans-serif",
  };

  const renderSelect = (
    value,
    disabled,
    placeholder,
    items,
    dropdownName,
    isLoading
  ) => (
    <FormControl fullWidth>
      <Select
        value={value}
        sx={commonSelectStyles}
        MenuProps={{
          sx: { minHeight: "350px", maxHeight: "350px" },
        }}
        onChange={(e) => handleDropdownChange(dropdownName, e.target.value)}
        disabled={disabled}
      >
        <MenuItem value={dropdownName === "dropdown1" ? "Select" : "0"} disabled>
          {placeholder}
        </MenuItem>
        {isLoading ? (
          <LoadingMenuItem />
        ) : (
          items
        )}
      </Select>
    </FormControl>
  )

  return (
    <>
      <Grid items className="search-form">
        <Typography
          fontFamily="'Barlow', sans-serif"
          sx={{
            fontWeight: "700",
            fontSize: "22px",
            lineHeight: "31.2px",
            textTransform: "uppercase",
            color: "#FF6633",
            textAlign: "center",
            mb: 2
          }}
        >
          Search <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: "600", color: "#000000" }}>By </span>
          <span style={{ fontWeight: "700", color: "#000000" }}>Vehicle</span>
        </Typography>

        <Grid container spacing={{ sm: 1, xs: 2, md: 1 }}>
          <Grid item xs={6} sm={6} md={6}>
            {renderSelect(
              dropdownValues.dropdown1,
              false,
              "Select Car Brand",
              brandsList.length > 0 && brandsList
                ?.filter((item) => item.oem === 1)
                ?.map((brand, index) => (
                  <MenuItem key={index} value={brand?.id}>{brand?.name}</MenuItem>
                )),
              "dropdown1",
              false
            )}
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            {renderSelect(
              dropdownValues.dropdown2,
              !dropdownEnabled["dropdown2"],
              "Select Car Model",
              modelsList.length > 0 && modelsList?.map((model, index) => (
                <MenuItem key={index} value={model?.id}>{model?.name}</MenuItem>
              )),
              "dropdown2",
              loading.models
            )}
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            {renderSelect(
              dropdownValues.dropdown3,
              !dropdownEnabled["dropdown3"],
              "Select Year",
              yearsList.length > 0 && yearsList?.map((year, index) => (
                <MenuItem key={index} value={year}>{year}</MenuItem>
              )),
              "dropdown3",
              loading.years
            )}
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            {renderSelect(
              dropdownValues.dropdown4,
              !dropdownEnabled["dropdown4"],
              "Select Variant",
              varientList?.varients?.length > 0 &&
              varientList?.varients.map((item, index) => (
                <MenuItem key={index} value={item?.compatibility_group_id}>
                  {`${item?.varient} / ${item?.fuel_engine}`}
                </MenuItem>
              )),
              "dropdown4",
              loading.variants
            )}
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              // disabled={dropdownValues?.dropdown4 === "0"}
              sx={{
                backgroundColor: "#FF6633",
                fontFamily: "'Barlow', sans-serif",
                textTransform: "none",
                fontSize: "16px",
                height: isMobile ? "45px" : "45px",
                borderRadius: isMobile ? "7px" : "10px",
                // width: isMobile ? "100%" : "344px",
                "&:hover": {
                  backgroundColor: "#FF6633"
                }
              }}
              onClick={() => {
                if (dropdownValues.dropdown4 !== "0") {
                  handleSearch();
                  !isMobile && handleAdd1();
                }
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>

        <Box sx={{
          mt: { xs: 3, sm: 2, md: 3 },
          background: "#FFFFFF",
          borderRadius: "10px",
          p: { xs: 2, sm: 1, md: 2 },
        }}>
          <Typography
            fontFamily="'Barlow', sans-serif"
            sx={{
              textAlign: "center",
              fontWeight: "700",
              fontSize: isMobile ? "16px" : "20px",
              lineHeight: isMobile ? "20px" : "31.2px",
              textTransform: "uppercase",
              color: "#000000",
              mb: 2
            }}
          >
            Search By Number Plate
          </Typography>

          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1
          }}>
            <Box sx={{
              backgroundColor: "rgba(225, 226, 227, 1)",
              padding: "3px",
              borderRadius: "2px"
            }}>
              <Input
                fullWidth
                disableUnderline
                placeholder="MH01XY0001"
                onKeyDown={handleKeyPress}
                startAdornment={(
                  <InputAdornment position="start">
                    <img
                      src={ind_number_plat}
                      alt="plate"
                      style={{
                        width: isMobile ? '15px' : '13px',
                        marginRight: '-13px',
                        marginLeft: '5px',
                        marginTop: isMobile ? '7px' : '1px'
                      }}
                    />
                  </InputAdornment>
                )}
                sx={{
                  height: isMobile ? "32px" : "32px",
                  width: isMobile ? "170px" : "170px",
                  backgroundColor: "white",
                  '& input': {
                    padding: '10px 0px 10px 10px',
                    fontSize: '22px',
                    '::placeholder': {
                      fontSize: '22px',
                      paddingTop: '9px'
                    }
                  }
                }}
                value={numberPlateSearch}
                onChange={handleNumberPlateChange}
              />
            </Box>
            <Button
              onClick={handleSearchAndOpenDialog}
              variant="contained"
              sx={{
                backgroundColor: "#FF6633",
                width: '108px',
                height: '37px',
                lineHeight: "19.2px",
                fontWeight: 500,
                fontFamily: "'Barlow', sans-serif",
                textTransform: "none",
                borderRadius: "7px",
                fontSize: "13px",
                "&:hover": {
                  backgroundColor: "#FF6633"
                }
              }}
              disableElevation
            >
              Search
            </Button>
          </Box>
        </Box>
      </Grid>
    </>
  )
};

const HomeSection1 = ({ images }) => {
  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();
  const loggedIn = localStorage.getItem("is_login");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [imageLoaded, setImageLoaded] = useState(false);
  const { selectedCar, fetchSelectedCar } = useSelectedCar();
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));
  const isSmScreen = useMediaQuery(theme.breakpoints.only('sm'));
  const isMdScreen = useMediaQuery(theme.breakpoints.only('md'));
  const isLgScreen = useMediaQuery(theme.breakpoints.only('lg'));
  const isXlScreen = useMediaQuery(theme.breakpoints.only('xl'));
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState({
    brands: false,
    models: false,
    years: false,
    variants: false,
  });

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchAndOpenDialog();
    }
  };

  const [dropdownValues, setDropdownValues] = useState({
    dropdown1: "Select",
    dropdown2: "0",
    dropdown3: "0",
    dropdown4: "0",
  });

  const [dropdownEnabled, setDropdownEnabled] = useState({
    dropdown1: true,
    dropdown2: false,
    dropdown3: false,
    dropdown4: false,
  });

  const [brandsList, setBrandsList] = useState([]);
  const [modelsList, setModelsList] = useState([]);
  const [compatibilitysList, setCompatibilitysList] = useState("");
  const [yearsList, setYearsList] = useState([]);
  const [numberPlateSearch, setNumberPlateSearch] = useState("");
  const [varientList, setvarientList] = useState([])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, [images]);
  const getContainerStyle = () => {
    if (windowWidth >= 1200) {
      // Desktop
      return { width: "100%", height: "500px" };
    } else if (windowWidth >= 900) {
      // Tablet
      return { width: "100%", height: "450px", };
    } else if (windowWidth >= 768) {
      // Tablet
      return { width: "100%", height: "350px", };
    } else {
      // Mobile
      return { width: "100%", height: "250px", };
    }
  };


  const handleDropdownChange = useCallback(async (dropdownName, value) => {
    const dropdownNumber = parseInt(dropdownName.slice(-1));

    // Update the selected value
    setDropdownValues(prev => {
      const newValues = { ...prev, [dropdownName]: value };
      // Reset subsequent dropdowns
      for (let i = dropdownNumber + 1; i <= 4; i++) {
        newValues[`dropdown${i}`] = "0";
      }
      return newValues;
    });

    // Set loading state based on which dropdown changed
    if (dropdownName === 'dropdown1') {
      setLoading(prev => ({ ...prev, models: true }));
    } else if (dropdownName === 'dropdown2') {
      setLoading(prev => ({ ...prev, years: true }));
    } else if (dropdownName === 'dropdown3') {
      setLoading(prev => ({ ...prev, variants: true }));
    }

    setDropdownEnabled(prev => {
      const newEnabled = { ...prev };
      for (let i = dropdownNumber + 1; i <= 4; i++) {
        newEnabled[`dropdown${i}`] = false;
      }
      const nextDropdown = `dropdown${dropdownNumber + 1}`;
      if (nextDropdown in newEnabled) {
        newEnabled[nextDropdown] = true;
      }
      return newEnabled;
    });
  }, []);



  const handleSearch = () => {
    navigate({
      pathname: `products-list`,
      search: `?car_model_id=${dropdownValues.dropdown4}`,
    });
    setDropdownValues((options) => ({
      ...options,
      dropdown1: "Select",
      dropdown2: "0",
      dropdown3: "0",
      dropdown4: "0",
    }));
    setDropdownEnabled((options) => ({
      ...options,
      dropdown2: false,
      dropdown3: false,
      dropdown4: false,
    }));
  };

  useEffect(() => {
    const fetchBrands = async () => {
      setLoading(prev => ({ ...prev, brands: true }));
      try {
        const brands = await getCarBrands();
        if (brands.code === 200) {
          setBrandsList(brands.data);
        } else {
          setBrandsList([]);
        }
      } catch (error) {
        setBrandsList([]);
        toast.error("Error fetching car brands:", error);
      }
    };
    fetchBrands();
  }, []);


  useEffect(() => {
    const fetchModels = async () => {
      if (dropdownValues.dropdown1 !== "Select") {
        setLoading(prev => ({ ...prev, models: true }));
        try {
          const Models = await getCarModels(dropdownValues.dropdown1);
          if (Models?.code === 200) {
            setModelsList(Models?.data);
          } else {
            setModelsList([]);
          }
        } catch (e) {
          setModelsList([]);
          toast.error("Error fetching car models");
        } finally {
          setLoading(prev => ({ ...prev, models: false }));
        }
      }
    };
    fetchModels();
  }, [dropdownValues.dropdown1]);


  useEffect(() => {
    const fetchCompatibility = async () => {
      if (dropdownValues.dropdown2 !== "0") {
        setLoading(prev => ({ ...prev, years: true }));
        try {
          const compatibility = await getCarCompatibilitys(dropdownValues.dropdown2);
          setCompatibilitysList(compatibility);
        } catch (e) {
          toast.error("Error fetching compatibility data");
        } finally {
          setLoading(prev => ({ ...prev, years: false }));
        }
      }
    };
    fetchCompatibility();
  }, [dropdownValues.dropdown2]);

  useEffect(() => {
    const getCarVarientList = async () => {
      if (dropdownValues.dropdown2 !== "0" && dropdownValues.dropdown3 !== "0") {
        setLoading(prev => ({ ...prev, variants: true }));
        try {
          const varient = await getCarCompatibilitysVarient(
            dropdownValues.dropdown2,
            dropdownValues.dropdown3
          );
          if (varient.code === 200) {
            setvarientList(varient.data);
          } else {
            setvarientList([]);
          }
        } catch (e) {
          setvarientList([]);
          toast.error("Error fetching variant data");
        } finally {
          setLoading(prev => ({ ...prev, variants: false }));
        }
      }
    };

    if (dropdownValues.dropdown2 !== "0" && dropdownValues.dropdown3 !== "0") {
      getCarVarientList();
    }
  }, [dropdownValues.dropdown2, dropdownValues.dropdown3]);



  useEffect(() => {
    if (compatibilitysList && dropdownValues.dropdown2 !== "") {
      const years = Array.from(
        { length: compatibilitysList.end_year - compatibilitysList.start_year + 1 },
        (_, i) => compatibilitysList.start_year + i
      );
      setYearsList(years);
    }
  }, [compatibilitysList, dropdownValues.dropdown2]);



  const resetNumberPlateSearch = () => {
    setNumberPlateSearch("");
  };

  const [isNumberPlateDialogOpen, setNumberPlateDialogOpen] = useState(false);

  const handleNumberPlateButtonClick = () => {
    setNumberPlateDialogOpen(true);
  };

  const handleCloseNumberPlateDialog = () => {
    setNumberPlateDialogOpen(false);
    setNumberPlateData(null);
    setNumberPlateSearch("");
  };

  const [numberPlateData, setNumberPlateData] = useState(null);
  const [numberplateLoading, setNumberplateLoading] = useState(false);

  const numplateSearch = async () => {
    setOpenBackdrop(true);
    setNumberplateLoading(true);
    const result = await getNumberplate(numberPlateSearch);

    if (result?.code === 200) {
      setNumberPlateData(result.data);
      setOpenBackdrop(false);
      setNumberplateLoading(false);
    } else {
      setNumberPlateData(null);
      setOpenBackdrop(false);
      setNumberplateLoading(false);
      console.error("Error fetching number plate data");
    }
  }

  const handleNumberPlateChange = (e) => {
    const value = e.target.value.toUpperCase();
    const sanitizedValue = value.replace(/[^A-Z0-9]/g, '');
    setNumberPlateSearch(sanitizedValue);
  };


  const handleSearch2 = (data) => {
    navigate({
      pathname: `products-list`,
      search: `?car_model_id=${data}`,
    });
  };

  const navigateToOEMCatalog = useCallback(async (data) => {
    setOpenBackdrop(true);
    setNumberplateLoading(true);

    try {
      const response = await getcatelogcategory(data.modification_id, data.brand_id);
      if (response?.code === 200) {
        navigate(`/catelog-category?car_model_id=${data.modification_id}&brand_id=${data.brand_id}`, {
          state: { apiResponse: response.data },
        });
      } else {
        toast.error(response?.msg);
      }
    } catch (error) {
      toast.error("Error navigating to catalog");
    } finally {
      setOpenBackdrop(false);
      setNumberplateLoading(false);
    }
  }, [navigate]);

  const handleSearchAndOpenDialog = async () => {
    if (loggedIn) {
      await numplateSearch();
      handleNumberPlateButtonClick();
    } else {
      navigate("/login");
    }
  };

  const handleAdd = async (params) => {
    if (loggedIn) {

      const data = {
        brand_id: params.brand_id,
        variant: params.modification_id,
      }

      const result = await addUserCar(data);
      if (result?.code === 200) {
        // toast.success(result?.msg, {
        //   position: "bottom-center",
        // });
        // ToastNotification(result?.msg, "success");
        fetchSelectedCar();
      } else {
        toast.error(result?.msg, {
          position: "bottom-center",
        });
        // ToastNotification(result?.msg, "error");
      }
    } else {
      // ToastNotification("Please login first", "error");
      toast.error("Please login first", {
        position: "bottom-center",
      });
    }
  };

  const handleAdd1 = async () => {
    if (loggedIn) {
      const data = {
        brand_id: dropdownValues.dropdown1,
        variant: dropdownValues.dropdown4,
      };

      const result = await addUserCar(data);
      if (result?.code === 200) {
        // ToastNotification(result?.msg, "success");
        toast.success(result?.msg, {
          position: "bottom-center",
        });
      } else {
        toast.error(result?.msg, {
          position: "bottom-center",
        });
        // ToastNotification(result?.msg, "error");
      }
    } else {
      console.log("Please login first");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setImageLoaded(false);
      setWindowWidth(window.innerWidth);
      // Re-trigger image load to adjust the size
      setTimeout(() => setImageLoaded(true), 100);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cityNames = [
    "Agra", "Ahmedabad", "Ajmer", "Allahabad", "Amritsar", "Aurangabad", "Bangalore", "Bhopal",
    "Chandigarh", "Chennai", "Coimbatore", "Delhi", "Faridabad", "Gurgaon", "Guwahati", "Hyderabad",
    "Indore", "Jaipur", "Jodhpur", "Kanpur", "Kochi", "Kolkata", "Lucknow", "Ludhiana", "Mumbai",
    "Nagpur", "Noida", "Patna", "Pune", "Surat", "Thiruvananthapuram", "Vadodara", "Varanasi", "Visakhapatnam"
  ];


  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <ToastContainer />
      <Grid >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexGrow: 1,
            justifyContent: "center",
            alignItems: "center",
            maxHeight: "500px",
            // width: "100%", // Full width
          }}
        >
          {!imageLoaded && (
            isMobile ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="100%"
                height="30vh"
              />
            ) : (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="100%"
                height="500px"
              />
            )
          )}

          <Carousel
            autoPlay
            infiniteLoop
            interval={5000}
            showThumbs={false}
            showStatus={false}
            showArrows={true}
            showIndicators={true}
          >
            {images.map((image) => (
              <div key={image.id} style={getContainerStyle()} >
                <img
                  src={image.image}
                  onLoad={handleImageLoad}
                  style={{
                    display: imageLoaded ? "block" : "none",
                    width: "100%",
                    height: "100%",
                    objectFit: isMobile ? "contain" : "fill",
                  }}
                  alt="banner_image"
                />
              </div>
            ))}
          </Carousel>
          {!isMobile && (
            <>
              <Box
                sx={{
                  position: "absolute",
                  top: { xl: "15%", lg: "15%", md: "10%", sm: "0%" },
                  left: { xl: "8%", lg: "10%", md: "5%", sm: "2%" },
                  backgroundColor: "#f5f5f5",
                  padding: "15px",
                  zIndex: 1,
                  borderRadius: "10px",
                  width: { xl: "360px", lg: "350px", md: "380px", sm: "340px" },
                  display: { xs: "none", lg: "block", md: "block", sm: "block" }
                }}
              >
                <>
                  <SearchForm
                    isMobile={isMobile}
                    brandsList={brandsList}
                    yearsList={yearsList}
                    compatibilitysList={compatibilitysList}
                    modelsList={modelsList}
                    handleSearchAndOpenDialog={handleSearchAndOpenDialog}
                    handleSearch={handleSearch}
                    handleAdd1={handleAdd1}
                    handleNumberPlateChange={handleNumberPlateChange}
                    handleDropdownChange={handleDropdownChange}
                    handleKeyPress={handleKeyPress}
                    dropdownEnabled={dropdownEnabled}
                    dropdownValues={dropdownValues}
                    numberPlateSearch={numberPlateSearch}
                    varientList={varientList}
                    setDropdownValues={setDropdownValues}
                    setDropdownEnabled={setDropdownEnabled}
                    setLoading={setLoading}
                    loading={loading}
                  />
                </>
              </Box>
            </>
          )}

        </Box >
      </Grid>

      {isMobile && (
        <Container maxWidth="xl">
          <Box sx={{ py: 3, px: 2 }}>
            <>
              <SearchForm
                isMobile={isMobile}
                brandsList={brandsList}
                yearsList={yearsList}
                compatibilitysList={compatibilitysList}
                modelsList={modelsList}
                handleSearchAndOpenDialog={handleSearchAndOpenDialog}
                handleSearch={handleSearch}
                handleAdd1={handleAdd1}
                handleNumberPlateChange={handleNumberPlateChange}
                handleDropdownChange={handleDropdownChange}
                handleKeyPress={handleKeyPress}
                dropdownEnabled={dropdownEnabled}
                dropdownValues={dropdownValues}
                numberPlateSearch={numberPlateSearch}
                setDropdownValues={setDropdownValues}
                setDropdownEnabled={setDropdownEnabled}
                setLoading={setLoading}
                loading={loading}
                varientList={varientList}
              />
            </>
          </Box>
        </Container>
      )}

      <NumberPlateDialog
        isNumberPlateDialogOpen={isNumberPlateDialogOpen}
        setNumberPlateDialogOpen={setNumberPlateDialogOpen}
        handleNumberPlateButtonClick={handleNumberPlateButtonClick}
        handleCloseNumberPlateDialog={handleCloseNumberPlateDialog}
        numberPlateSearch={numberPlateSearch}
        numberPlateData={numberPlateData}
        setNumberPlateData={setNumberPlateData}
        handleSearch2={handleSearch2}
        navigateToOEMCatalog={navigateToOEMCatalog}
        handleSearchAndOpenDialog={handleSearchAndOpenDialog}
        handleAdd={handleAdd}
        resetNumberPlateSearch={resetNumberPlateSearch}
        setNumberPlateSearch={setNumberPlateSearch}
        numplateSearch={numplateSearch}
        isloading={numberplateLoading}
        handleKeyPress={handleKeyPress}
      />
    </>
  );
};


export default HomeSection1;